export default __webpack_public_path__ + "static/media/studentLogin2.f6f4fece.gif";